const data =
  "본 페이지는 ‘나는 우리나라 미라 과학자’ 시범전시 콘텐츠에 대하여 이를 제작하는데 들어간 핵심기술을 국내의 여러 과학관 및 박물관에서 사용할 수 있도록 개발자를 위한 기반기술과 비개발자도 활용할 수 있는 콘텐츠제작 프로그램을 배포하기 위하여 만들어졌습니다. ";

const data1 =
  "한국자연사박물관의 ‘학봉장군 미라’를 주제로 하는 ‘나는 우리나라 미라과학자’ 콘텐츠는 우리나라의 유일한 미라전시관을 소개하면서 그 속에 담긴 이야기를 단순히 글이나 그림으로 제공하는 것이 아니라 다감각을 활용한 체험을 통하여 전달의 효과를 높이고자 하였습니다. 실제 미라의 3차원 CT영상을 활용하고 전시관 내 전시중인 전시품을 3차원 스캔하여 제작하는 등 콘텐츠의 사실성에도 주의를 기울였습니다. 이와 더불어 여러 콘텐츠에 다양한 종류의 기술을 접목시켰으며 시범전시를 통해 각 기반기술이 보여줄 수 있는 전시효과를 입증하였습니다.\n";
const data2 =
  "실제 미라와 사람의 CT데이터의 시각화를 통해 서로를 비교해보면서 미라화 과정을 거치면서 몸 속의 장기들이 어떻게 변화하는지 확인하는 콘텐츠입니다. 기본적인 볼륨렌더링 시각화기법이 들어갔으며 원하는부분을 강조하여 시각화할 수 있습니다.";
const data3 =
  "우리가 보통 ‘미라’하면 떠올리는 이집트미라와 자연적으로 생성된 미라에 어떠한 차이가 있을지 터치스크린을 통하여 직접 머리내부를 열어보고 관찰하면서 그 차이를 배울 수 있는 콘텐츠입니다. SketchScope 기법을 활용하여 사용자가 원하는 내부구조를 볼수있도록 시각화결과를 변화할수 있습니다.";
const data4 =
  "우리나라 미라가 발굴되는 과정을 햅틱장비를 통해 체험해보면서 우리나라에서는 어떻게 미라가 만들어졌는지 배울 수 있는 콘텐츠입니다. 접촉식 햅틱장비를 사용하는 Haptic Interface기법이 사용되어 물체를 만지거나 움직일 수 있고 그에 따라 중력, 반발력, 자기력과 같은 다양한 종류의 힘을 출력할 수 있습니다.";
const data5 =
  "‘나는 우리나라 미라 과학자’ 컨텐츠를 동영상을 통해 체험해 보세요.";
export { data, data1, data2, data3, data4, data5 };
